import { lazyWithRetry as lazy } from "@/utils/lazyWithRetry";
// Every page loads on demand: eagerly importing them put all of them in the
// first download (a 9 MB main bundle), so the dashboard waited for Reports,
// Automation, WhatsApp… before it could show. AppLayout's Suspense keeps the
// sidebar and header up while a page's chunk arrives.
const Dashboard = lazy(() => import("@/page/Dashboard"));
const ActivityPage = lazy(() => import("@/page/ActivityPage"));
const KeyInsightsPage = lazy(() => import("@/page/KeyInsightsPage"));
const loadLeadsPage = () => import("@/page/core/leads/LeadsPage");
const LeadsPage = lazy(loadLeadsPage);
const UniversityPage = lazy(() => import("@/page/niche/education/UniversityPage"));
const VideoProduction = lazy(() => import("@/page/niche/video-production/VideoProduction"));
const StagePage = lazy(() => import("@/page/configuration/stageManagement/StagePage"));
const UsersPage = lazy(() => import("@/page/configuration/userManagement/UsersPage"));
const Prefrences = lazy(() => import("@/page/configuration/prefrenceManagement/Prefrences"));
const SourcePage = lazy(() => import("@/page/configuration/sourceManagement/SourcePage"));
const Dynamics = lazy(() => import("@/page/core/dynamic/Dynamics"));
const Automation = lazy(() => import("@/page/configuration/automation/Automation"));
const SettingsPage = lazy(() => import("@/page/configuration/settings/settingsPage"));
const ReportPage = lazy(() => import("@/page/configuration/reportManagement/ReportPage"));
const Whatsapp = lazy(() => import("@/page/core/whatsapp/Whatsapp"));
const Gmail = lazy(() => import("@/page/core/gmail/Gmail"));
const StudentPortalPage = lazy(() => import("@/page/configuration/studentPortal/StudentPortalPage"));
const ProgramPage = lazy(() => import("@/page/niche/academy/ProgramPage"));
const FavoriteViewPage = lazy(() => import("@/page/core/favoriteViews/FavoriteViewPage"));
// INTEGRATION group — served only while the tool is connected (server /tabs).
const RazorpayPage = lazy(() => import("@/page/integration/razorpay/RazorpayPage"));
const ConnectedToolsPage = lazy(() => import("@/page/integration/connectedTools/ConnectedToolsPage"));

/** The leads page is where most people go next: fetch its chunk once the
 *  browser is idle so the first click on it doesn't wait for the download. */
export function prefetchCommonPages(): void {
  if (typeof window === "undefined") return;
  const idle =
    (window as Window & { requestIdleCallback?: (cb: () => void) => void }).requestIdleCallback ??
    ((cb: () => void) => window.setTimeout(cb, 2000));
  idle(() => void loadLeadsPage().catch(() => undefined));
}

export const ROUTE_COMPONENTS: Record<string, React.ComponentType> = {
  Dashboard,
  ActivityPage,
  KeyInsightsPage,
  LeadsPage,
  UniversityPage,
  VideoProduction,
  ProgramPage,
  StagePage,
  UsersPage,
  Prefrences,
  SourcePage,
  Dynamics,
  FavoriteViewPage,
  Automation,
  SettingsPage,
  ReportPage,
  Whatsapp,
  Gmail,
  StudentPortalPage,
  RazorpayPage,
  ConnectedToolsPage,
};
